// Module
var code = "<react-component name=\"MembershipPlansList\"></react-component>\n";
// Exports
module.exports = code;